import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { CONFIGS } from '../../config'
import type { IOrderResponse, IOrdersResponse } from '../../types/api/orders.d'
import { publicRequest } from './publicRequest'

export const getOrders = async (
  page: number,
  limit: number,
  eventSlug: string
): Promise<IOrdersResponse> => {
  const slug = eventSlug || CONFIGS.EVENT_SLUG || ''

  const response: AxiosResponse<IOrdersResponse, AxiosRequestConfig> =
    await publicRequest.get(
      `v1/account/orders/?page=${page}&limit=${limit}&filter[event]=${slug}&${
        CONFIGS.BRAND_SLUG
          ? `filter[brand]=${CONFIGS.BRAND_SLUG}&filter[subbrands]=true`
          : ''
      }`
    )

  return response.data
}

export const getOrderDetails = async (orderId: string): Promise<IOrderResponse> => {
  const response: AxiosResponse<IOrderResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/account/order/${orderId}`)

  return response.data
}
